const nations = [
  {
    value: 'Canada',
    icon: 'canada',
    code: 1,
    currencySymbol: '$'
  },
  {
    value: 'Denmark',
    icon: 'denmark',
    code: 45,
    currencySymbol: 'kr'
  },
  {
    icon: 'france',
    value: 'France',
    code: 33,
    currencySymbol: '€'
  },
  {
    value: 'Hong Kong',
    icon: 'hongKong',
    code: 852,
    currencySymbol: '$'
  },
  {
    value: 'Italy',
    icon: 'italy',
    code: 39,
    currencySymbol: '€'
  },
  {
    value: 'Japan',
    icon: 'japan',
    code: 81,
    currencySymbol: '¥'
  },
  {
    value: 'Netherlands',
    icon: 'netherlands',
    code: 31,
    currencySymbol: '€'
  },
  {
    value: 'Philippines',
    icon: 'philippines',
    code: 63,
    currencySymbol: '₱'
  },
  {
    value: 'Spain',
    icon: 'spain',
    code: 34,
    currencySymbol: '€'
  },
  {
    value: 'Ukraine',
    icon: 'ukraine',
    code: 380,
    currencySymbol: '₴'
  },
  {
    value: 'United Kingdom',
    icon: 'unitedKingdom',
    code: 44,
    currencySymbol: '£'
  },
  {
    value: 'United States',
    icon: 'unitedStates',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'afghanistan',
    value: 'Afghanistan',
    code: 93,
    currencySymbol: '؋'
  },
  {
    icon: 'albania',
    value: 'Albania',
    code: 355,
    currencySymbol: 'L'
  },
  {
    icon: 'algeria',
    value: 'Algeria',
    code: 213,
    currencySymbol: 'دج'
  },
  {
    icon: 'americanSamoa',
    value: 'American Samoa',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'andorra',
    value: 'Andorra',
    code: 376,
    currencySymbol: '€'
  },
  {
    icon: 'angola',
    value: 'Angola',
    code: 244,
    currencySymbol: 'Kz'
  },
  {
    icon: 'anguilla',
    value: 'Anguilla',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'antiguaAndBarbuda',
    value: 'Antigua And Barbuda',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'armenia',
    value: 'Armenia',
    code: 374,
    currencySymbol: '֏'
  },
  {
    icon: 'aruba',
    value: 'Aruba',
    code: 297,
    currencySymbol: 'ƒ'
  },
  {
    icon: 'australia',
    value: 'Australia',
    code: 61,
    currencySymbol: '$'
  },
  {
    value: 'Austria',
    icon: 'austria',
    code: 43,
    currencySymbol: '€'
  },
  {
    icon: 'azerbaijan',
    value: 'Azerbaijan',
    code: 994,
    currencySymbol: '₼'
  },
  {
    icon: 'bahamas',
    value: 'Bahamas',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'bahrain',
    value: 'Bahrain',
    code: 973,
    currencySymbol: '.د.ب'
  },
  {
    icon: 'balearicIslands',
    value: 'Balearic Islands',
    code: 34,
    currencySymbol: '€'
  },
  {
    icon: 'barbados',
    value: 'Barbados',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'basqueCountry',
    value: 'Basque Country',
    code: 34,
    currencySymbol: '€'
  },
  {
    icon: 'belarus',
    value: 'Belarus',
    code: 375,
    currencySymbol: 'Br'
  },
  {
    icon: 'belgium',
    value: 'Belgium',
    code: 32,
    currencySymbol: '€'
  },
  {
    icon: 'belize',
    value: 'Belize',
    code: 501,
    currencySymbol: '$'
  },
  {
    icon: 'benin',
    value: 'Benin',
    code: 229,
    currencySymbol: 'CFA'
  },
  {
    icon: 'bermuda',
    value: 'Bermuda',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'bhutan',
    value: 'Bhutan',
    code: 975,
    currencySymbol: 'Nu.'
  },
  {
    icon: 'britishIndianOceanTerritory',
    value: 'British Indian Ocean Territory',
    code: 246,
    currencySymbol: '$'
  },
  {
    icon: 'britishVirginIslands',
    value: 'British Virgin Islands',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'brunei',
    value: 'Brunei',
    code: 673,
    currencySymbol: '$'
  },
  {
    icon: 'bulgaria',
    value: 'Bulgaria',
    code: 359,
    currencySymbol: 'лв'
  },
  {
    icon: 'burkinaFaso',
    value: 'Burkina Faso',
    code: 226,
    currencySymbol: 'CFA'
  },
  {
    icon: 'cambodia',
    value: 'Cambodia',
    code: 855,
    currencySymbol: '៛'
  },
  {
    icon: 'cameroon',
    value: 'Cameroon',
    code: 237,
    currencySymbol: 'CFA'
  },
  {
    icon: 'canaryIslands',
    value: 'Canary Islands',
    code: 34,
    currencySymbol: '€'
  },
  {
    icon: 'capeVerde',
    value: 'Cape Verde',
    code: 238,
    currencySymbol: 'CVE'
  },
  {
    icon: 'caymanIslands',
    value: 'Cayman Islands',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'centralAfricanRepublic',
    value: 'Central African Republic',
    code: 236,
    currencySymbol: 'CFA'
  },
  {
    icon: 'ceuta',
    value: 'Ceuta',
    code: 956,
    currencySymbol: '€'
  },
  {
    icon: 'chad',
    value: 'Chad',
    code: 235,
    currencySymbol: 'CFA'
  },
  {
    icon: 'china',
    value: 'China',
    code: 86,
    currencySymbol: '¥'
  },
  {
    icon: 'cocosIslands',
    value: 'Cocos Islands',
    code: 61,
    currencySymbol: '$'
  },
  {
    icon: 'colombia',
    value: 'Colombia',
    code: 57,
    currencySymbol: '$'
  },
  {
    icon: 'comoros',
    value: 'Comoros',
    code: 269,
    currencySymbol: 'CF'
  },
  {
    icon: 'corsica',
    value: 'Corsica',
    code: 33,
    currencySymbol: '€'
  },
  {
    icon: 'costaRica',
    value: 'CostaRica',
    code: 506,
    currencySymbol: '₡'
  },
  {
    icon: 'croatia',
    value: 'Croatia',
    code: 385,
    currencySymbol: 'kn'
  },
  {
    icon: 'curacao',
    value: 'Curacao',
    code: 599,
    currencySymbol: 'ƒ'
  },
  {
    icon: 'cyprus',
    value: 'Cyprus',
    code: 357,
    currencySymbol: '€'
  },
  {
    icon: 'czechRepublic',
    value: 'Czech Republic',
    code: 420,
    currencySymbol: 'Kč'
  },
  {
    icon: 'congo',
    value: 'Democratic Republic of the Congo',
    code: 243,
    currencySymbol: 'FC'
  },
  {
    icon: 'djibouti',
    value: 'Djibouti',
    code: 253,
    currencySymbol: 'Fdj'
  },
  {
    icon: 'dominica',
    value: 'Dominica',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'dominicanRepublic',
    value: 'Dominican Republic',
    code: 1,
    currencySymbol: 'RD$'
  },
  {
    icon: 'eastTimor',
    value: 'EastTimor',
    code: 670,
    currencySymbol: '$'
  },
  {
    icon: 'egypt',
    value: 'Egypt',
    code: 20,
    currencySymbol: '£'
  },
  {
    icon: 'elSalvador',
    value: 'El Salvador',
    code: 503,
    currencySymbol: '$'
  },
  {
    icon: 'england',
    value: 'England',
    code: 44,
    currencySymbol: '£'
  },
  {
    icon: 'equatorialGuinea',
    value: 'Equatorial Guinea',
    code: 240,
    currencySymbol: 'CFA'
  },
  {
    icon: 'eritrea',
    value: 'Eritrea',
    code: 291,
    currencySymbol: 'Nfk'
  },
  {
    icon: 'estonia',
    value: 'Estonia',
    code: 372,
    currencySymbol: '€'
  },
  {
    icon: 'ethiopia',
    value: 'Ethiopia',
    code: 251,
    currencySymbol: 'Br'
  },
  {
    icon: 'europeanUnion',
    value: 'European Union',
    code: 0,
    currencySymbol: '€'
  },
  {
    icon: 'falklandIslands',
    value: 'Falkland Islands',
    code: 500,
    currencySymbol: '€'
  },
  {
    icon: 'fiji',
    value: 'Fiji',
    code: 679,
    currencySymbol: '£'
  },
  {
    icon: 'finland',
    value: 'Finland',
    code: 358,
    currencySymbol: '€'
  },
  {
    icon: 'frenchPolynesia',
    value: 'French Polynesia',
    code: 689,
    currencySymbol: '₣'
  },
  {
    icon: 'gabon',
    value: 'Gabon',
    code: 241,
    currencySymbol: 'CFA'
  },
  {
    icon: 'galapagosIslands',
    value: 'Galapagos Islands',
    code: 593,
    currencySymbol: '$'
  },
  {
    icon: 'gambia',
    value: 'Gambia',
    code: 220,
    currencySymbol: 'D'
  },
  {
    icon: 'georgia',
    value: 'Georgia',
    code: 995,
    currencySymbol: 'ლ'
  },
  {
    icon: 'brazil',
    value: 'Brazil',
    code: 55,
    currencySymbol: 'R$'
  },
  {
    icon: 'germany',
    value: 'Germany',
    code: 49,
    currencySymbol: '€'
  },
  {
    icon: 'gibraltar',
    value: 'Gibraltar',
    code: 350,
    currencySymbol: '£'
  },
  {
    icon: 'greece',
    value: 'Greece',
    code: 30,
    currencySymbol: '€'
  },
  {
    icon: 'greenland',
    value: 'Greenland',
    code: 299,
    currencySymbol: 'kr'
  },
  {
    icon: 'grenada',
    value: 'Grenada',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'guam',
    value: 'Guam',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'guatemala',
    value: 'Guatemala',
    code: 502,
    currencySymbol: 'Q'
  },
  {
    icon: 'guernsey',
    value: 'Guernsey',
    code: 44,
    currencySymbol: '£'
  },
  {
    icon: 'guinea',
    value: 'Guinea',
    code: 224,
    currencySymbol: 'FG'
  },
  {
    icon: 'guineaBissau',
    value: 'Guinea Bissau',
    code: 245,
    currencySymbol: 'CFA'
  },
  {
    icon: 'hawaii',
    value: 'Hawaii',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'honduras',
    value: 'Honduras',
    code: 504,
    currencySymbol: 'L'
  },
  {
    icon: 'hungary',
    value: 'Hungary',
    code: 36,
    currencySymbol: 'Ft'
  },
  {
    icon: 'iceland',
    value: 'Iceland',
    code: 354,
    currencySymbol: 'kr'
  },
  {
    icon: 'india',
    value: 'India',
    code: 91,
    currencySymbol: '₹'
  },
  {
    icon: 'indonesia',
    value: 'Indonesia',
    code: 62,
    currencySymbol: 'Rp'
  },
  {
    icon: 'iran',
    value: 'Iran',
    code: 98,
    currencySymbol: '﷼'
  },
  {
    icon: 'ireland',
    value: 'Ireland',
    code: 353,
    currencySymbol: '€'
  },
  {
    icon: 'isleOfMan',
    value: 'Isle Of Man',
    code: 44,
    currencySymbol: '£'
  },
  {
    icon: 'israel',
    value: 'Israel',
    code: 972,
    currencySymbol: '₪'
  },
  {
    icon: 'ivoryCoast',
    value: 'Ivory Coast',
    code: 225,
    currencySymbol: 'CFA'
  },
  {
    icon: 'jamacia',
    value: 'Jamacia',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'jersey',
    value: 'Jersey',
    code: 44,
    currencySymbol: '£'
  },
  {
    icon: 'jordan',
    value: 'Jordan',
    code: 962,
    currencySymbol: 'د.ا'
  },
  {
    icon: 'kazakhstan',
    value: 'Kazakhstan',
    code: 7,
    currencySymbol: '₸'
  },
  {
    icon: 'kenya',
    value: 'Kenya',
    code: 254,
    currencySymbol: 'KSh'
  },
  {
    icon: 'kiribati',
    value: 'Kiribati',
    code: 686,
    currencySymbol: '$'
  },
  {
    icon: 'kosovo',
    value: 'Kosovo',
    code: 383,
    currencySymbol: '€'
  },
  {
    icon: 'kuwait',
    value: 'Kuwait',
    code: 965,
    currencySymbol: 'د.ك'
  },
  {
    icon: 'kyrgyzstan',
    value: 'Kyrgyzstan',
    code: 996,
    currencySymbol: 'С̲'
  },
  {
    icon: 'laos',
    value: 'Laos',
    code: 856,
    currencySymbol: '₭'
  },
  {
    icon: 'latvia',
    value: 'Latvia',
    code: 371,
    currencySymbol: '€'
  },
  {
    icon: 'lebanon',
    value: 'Lebanon',
    code: 961,
    currencySymbol: 'ل.ل'
  },
  {
    icon: 'lesotho',
    value: 'Lesotho',
    code: 266,
    currencySymbol: 'L'
  },
  {
    icon: 'liberia',
    value: 'Liberia',
    code: 231,
    currencySymbol: '$'
  },
  {
    icon: 'libya',
    value: 'Libya',
    code: 218,
    currencySymbol: 'ل.د'
  },
  {
    icon: 'liechtenstein',
    value: 'Liechtenstein',
    code: 423,
    currencySymbol: 'CHF'
  },
  {
    icon: 'lithuania',
    value: 'Lithuania',
    code: 370,
    currencySymbol: '€'
  },
  {
    icon: 'luxembourg',
    value: 'Luxembourg',
    code: 352,
    currencySymbol: '€'
  },
  {
    icon: 'macao',
    value: 'Macao',
    code: 853,
    currencySymbol: 'MOP$'
  },
  {
    icon: 'madagascar',
    value: 'Madagascar',
    code: 261,
    currencySymbol: 'Ar'
  },
  {
    icon: 'madeira',
    value: 'Madeira',
    code: 351,
    currencySymbol: 'Ar'
  },
  {
    icon: 'malawi',
    value: 'Malawi',
    code: 265,
    currencySymbol: 'MK'
  },
  {
    icon: 'malaysia',
    value: 'Malaysia',
    code: 60,
    currencySymbol: 'RM'
  },
  {
    icon: 'maldives',
    value: 'Maldives',
    code: 960,
    currencySymbol: 'ރ'
  },
  {
    icon: 'mali',
    value: 'Mali',
    code: 223,
    currencySymbol: 'CFA'
  },
  {
    icon: 'malta',
    value: 'Malta',
    code: 356,
    currencySymbol: '€'
  },
  {
    icon: 'marshallIsland',
    value: 'Marshall Island',
    code: 692,
    currencySymbol: '$'
  },
  {
    icon: 'martinique',
    value: 'Martinique',
    code: 596,
    currencySymbol: '€'
  },
  {
    icon: 'mauritania',
    value: 'Mauritania',
    code: 222,
    currencySymbol: 'UM'
  },
  {
    icon: 'mauritius',
    value: 'Mauritius',
    code: 230,
    currencySymbol: '₨'
  },
  {
    icon: 'melilla',
    value: 'Melilla',
    code: 952,
    currencySymbol: '€'
  },
  {
    icon: 'mexico',
    value: 'Mexico',
    code: 52,
    currencySymbol: '$'
  },
  {
    icon: 'micronesia',
    value: 'Micronesia',
    code: 691,
    currencySymbol: '$'
  },
  {
    icon: 'moldova',
    value: 'Moldova',
    code: 373,
    currencySymbol: 'L'
  },
  {
    icon: 'monaco',
    value: 'Monaco',
    code: 377,
    currencySymbol: '€'
  },
  {
    icon: 'mongolia',
    value: 'Mongolia',
    code: 976,
    currencySymbol: '₮'
  },
  {
    icon: 'montenegro',
    value: 'Montenegro',
    code: 382,
    currencySymbol: '€'
  },
  {
    icon: 'montserrat',
    value: 'Montserrat',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'morocco',
    value: 'Morocco',
    code: 212,
    currencySymbol: 'DH'
  },
  {
    icon: 'mozambique',
    value: 'Mozambique',
    code: 258,
    currencySymbol: 'MT'
  },
  {
    icon: 'myanmar',
    value: 'Myanmar',
    code: 95,
    currencySymbol: 'Ks'
  },
  {
    icon: 'namibia',
    value: 'Namibia',
    code: 264,
    currencySymbol: '$'
  },
  {
    icon: 'nauru',
    value: 'Nauru',
    code: 674,
    currencySymbol: '$'
  },
  {
    icon: 'nepal',
    value: 'Nepal',
    code: 977,
    currencySymbol: '₨'
  },
  {
    icon: 'newZealand',
    value: 'New Zealand',
    code: 64,
    currencySymbol: '$'
  },
  {
    icon: 'nicaragua',
    value: 'Nicaragua',
    code: 505,
    currencySymbol: 'C$'
  },
  {
    icon: 'niger',
    value: 'Niger',
    code: 227,
    currencySymbol: 'CFA'
  },
  {
    icon: 'nigeria',
    value: 'Nigeria',
    code: 234,
    currencySymbol: '₦'
  },
  {
    icon: 'northKorea',
    value: 'North Korea',
    code: 850,
    currencySymbol: '₩'
  },
  {
    icon: 'northernCyprus',
    value: 'Northern Cyprus',
    code: 90,
    currencySymbol: '₺'
  },
  {
    icon: 'northernMarianasIslands',
    value: 'Northern Marianas Islands',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'norway',
    value: 'Norway',
    code: 47,
    currencySymbol: 'kr'
  },
  {
    icon: 'oman',
    value: 'Oman',
    code: 968,
    currencySymbol: 'ر.ع.'
  },
  {
    icon: 'orkneyIslands',
    value: 'Orkney Islands',
    code: 44,
    currencySymbol: '£'
  },
  {
    icon: 'ossetia',
    value: 'Ossetia',
    code: 7,
    currencySymbol: '₽'
  },
  {
    icon: 'pakistan',
    value: 'Pakistan',
    code: 92,
    currencySymbol: '₨'
  },
  {
    icon: 'palau',
    value: 'Palau',
    code: 680,
    currencySymbol: '$'
  },
  {
    icon: 'palestine',
    value: 'Palestine',
    code: 970,
    currencySymbol: '₪'
  },
  {
    icon: 'panama',
    value: 'Panama',
    code: 507,
    currencySymbol: 'B/.'
  },
  {
    icon: 'papuaNewGuinea',
    value: 'Papua New Guinea',
    code: 675,
    currencySymbol: 'K'
  },
  {
    icon: 'paraguay',
    value: 'Paraguay',
    code: 595,
    currencySymbol: '₲'
  },
  {
    icon: 'peru',
    value: 'Peru',
    code: 51,
    currencySymbol: 'S/.'
  },
  {
    icon: 'pitcairnIslands',
    value: 'Pitcairn Islands',
    code: 870,
    currencySymbol: 'NZ$'
  },
  {
    icon: 'poland',
    value: 'Poland',
    code: 48,
    currencySymbol: 'zł'
  },
  {
    icon: 'portugal',
    value: 'Portugal',
    code: 351,
    currencySymbol: '€'
  },
  {
    icon: 'puertoRico',
    value: 'Puerto Rico',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'qatar',
    value: 'Qatar',
    code: 974,
    currencySymbol: 'ر.ق'
  },
  {
    icon: 'rapaNui',
    value: 'RapaNui',
    code: 56,
    currencySymbol: 'CLP'
  },
  {
    icon: 'republicOfMacedonia',
    value: 'Republic of North Macedonia',
    code: 389,
    currencySymbol: 'ден'
  },
  {
    icon: 'republicOfTheCongo',
    value: 'Republic Of The Congo',
    code: 242,
    currencySymbol: 'FCFA'
  },
  {
    icon: 'romania',
    value: 'Romania',
    code: 40,
    currencySymbol: 'lei'
  },
  {
    value: 'Russia',
    icon: 'russia',
    code: 7,
    currencySymbol: '₽'
  },
  {
    icon: 'rwanda',
    value: 'Rwanda',
    code: 250,
    currencySymbol: 'FRw'
  },
  {
    icon: 'sabaIsland',
    value: 'Saba Island',
    code: 599,
    currencySymbol: '$'
  },
  {
    icon: 'sahwariArabDemocraticRepublic',
    value: 'Sahwari Arab Democratic Republic',
    code: 212,
    currencySymbol: 'DZD'
  },
  {
    icon: 'stBarts',
    value: 'Saint Barthelemy',
    code: 590,
    currencySymbol: '€'
  },
  {
    icon: 'stLucia',
    value: 'Saint Lucia',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'stVincentAndTheGrenadines',
    value: 'Saint VincentAndTheGrenadines',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'samoa',
    value: 'Samoa',
    code: 685,
    currencySymbol: 'T'
  },
  {
    icon: 'sanMarino',
    value: 'San Marino',
    code: 378,
    currencySymbol: '€'
  },
  {
    icon: 'saoTomeAndPrince',
    value: 'Sao Tome And Prince',
    code: 239,
    currencySymbol: 'Db'
  },
  {
    icon: 'sardinia',
    value: 'Sardinia',
    code: 39,
    currencySymbol: '€'
  },
  {
    icon: 'saudiArabia',
    value: 'Saudi Arabia',
    code: 966,
    currencySymbol: 'ر.س'
  },
  {
    icon: 'scotland',
    value: 'Scotland',
    code: 44,
    currencySymbol: '£'
  },
  {
    icon: 'senegal',
    value: 'Senegal',
    code: 221,
    currencySymbol: 'CFA'
  },
  {
    icon: 'serbia',
    value: 'Serbia',
    code: 381,
    currencySymbol: 'дин'
  },
  {
    icon: 'seychelles',
    value: 'Seychelles',
    code: 248,
    currencySymbol: '₨'
  },
  {
    icon: 'sierraLeone',
    value: 'Sierra Leone',
    code: 232,
    currencySymbol: 'Le'
  },
  {
    icon: 'singapore',
    value: 'Singapore',
    code: 65,
    currencySymbol: '$'
  },
  {
    icon: 'sintEustatius',
    value: 'Sint Eustatius',
    code: 1,
    currencySymbol: '€'
  },
  {
    icon: 'sintMaarten',
    value: 'Sint Maarten',
    code: 1,
    currencySymbol: 'ANG'
  },
  {
    icon: 'slovakia',
    value: 'Slovakia',
    code: 421,
    currencySymbol: '€'
  },
  {
    icon: 'slovenia',
    value: 'Slovenia',
    code: 386,
    currencySymbol: '€'
  },
  {
    icon: 'solomonIslands',
    value: 'Solomon Islands',
    code: 677,
    currencySymbol: '$'
  },
  {
    icon: 'somalia',
    value: 'Somalia',
    code: 252,
    currencySymbol: 'S'
  },
  {
    icon: 'somaliland',
    value: 'Somaliland',
    code: 252,
    currencySymbol: 'SLSH'
  },
  {
    icon: 'southAfrica',
    value: 'South Africa',
    code: 27,
    currencySymbol: 'R'
  },
  {
    icon: 'southKorea',
    value: 'South Korea',
    code: 82,
    currencySymbol: '₩'
  },
  {
    icon: 'southSudan',
    value: 'South Sudan',
    code: 211,
    currencySymbol: '£'
  },
  {
    icon: 'sriLanka',
    value: 'Sri Lanka',
    code: 94,
    currencySymbol: 'Rs'
  },
  {
    icon: 'sudan',
    value: 'Sudan',
    code: 249,
    currencySymbol: 'ج.س'
  },
  {
    icon: 'suriname',
    value: 'Suriname',
    code: 597,
    currencySymbol: '$'
  },
  {
    icon: 'swaziland',
    value: 'Swaziland',
    code: 268,
    currencySymbol: 'L'
  },
  {
    icon: 'sweden',
    value: 'Sweden',
    code: 46,
    currencySymbol: 'kr'
  },
  {
    icon: 'switzerland',
    value: 'Switzerland',
    code: 41,
    currencySymbol: 'CHF'
  },
  {
    icon: 'syria',
    value: 'Syria',
    code: 963,
    currencySymbol: '£'
  },
  {
    icon: 'taiwan',
    value: 'Taiwan',
    code: 886,
    currencySymbol: 'NT$'
  },
  {
    icon: 'tajikistan',
    value: 'Tajikistan',
    code: 992,
    currencySymbol: 'ЅМ'
  },
  {
    icon: 'tanzania',
    value: 'Tanzania',
    code: 255,
    currencySymbol: 'Sh'
  },
  {
    icon: 'thailand',
    value: 'Thailand',
    code: 66,
    currencySymbol: '฿'
  },
  {
    icon: 'tibet',
    value: 'Tibet',
    code: 86,
    currencySymbol: 'CNY'
  },
  {
    icon: 'togo',
    value: 'Togo',
    code: 228,
    currencySymbol: 'CFA'
  },
  {
    icon: 'tokelau',
    value: 'Tokelau',
    code: 690,
    currencySymbol: '$'
  },
  {
    icon: 'tonga',
    value: 'Tonga',
    code: 676,
    currencySymbol: 'T$'
  },
  {
    icon: 'transnistria',
    value: 'Transnistria',
    code: 373,
    currencySymbol: 'PRB'
  },
  {
    icon: 'trinidadAndTobago',
    value: 'Trinidad And Tobago',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'tunisia',
    value: 'Tunisia',
    code: 216,
    currencySymbol: 'د.ت'
  },
  {
    icon: 'turkey',
    value: 'Turkey',
    code: 90,
    currencySymbol: '₺'
  },
  {
    icon: 'turkmenistan',
    value: 'Turkmenistan',
    code: 993,
    currencySymbol: 'T'
  },
  {
    icon: 'turksAndCaicos',
    value: 'Turks And Caicos',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'tuvalu',
    value: 'Tuvalu',
    code: 688,
    currencySymbol: '$'
  },
  {
    icon: 'virginIslands',
    value: 'U.S. Virgin Islands',
    code: 1,
    currencySymbol: '$'
  },
  {
    icon: 'uganda',
    value: 'Uganda',
    code: 256,
    currencySymbol: 'USh'
  },
  {
    icon: 'unitedArabEmirates',
    value: 'United Arab Emirates',
    code: 256,
    currencySymbol: 'د.إ'
  },
  {
    icon: 'unitedNations',
    value: 'United Nations',
    code: 0,
    currencySymbol: '$'
  },

  {
    icon: 'uruguay',
    value: 'Uruguay',
    code: 598,
    currencySymbol: '$'
  },
  {
    icon: 'uzbekistan',
    value: 'Uzbekistan',
    code: 998,
    currencySymbol: 'лв'
  },
  {
    icon: 'vanuatu',
    value: 'Vanuatu',
    code: 678,
    currencySymbol: 'Vt'
  },
  {
    icon: 'vaticanCity',
    value: 'VaticanCity',
    code: 379,
    currencySymbol: '€'
  },
  {
    icon: 'venezuela',
    value: 'Venezuela',
    code: 58,
    currencySymbol: 'Bs'
  },
  {
    icon: 'vietnam',
    value: 'Vietnam',
    code: 84,
    currencySymbol: '₫'
  },
  {
    icon: 'wales',
    value: 'Wales',
    code: 44,
    currencySymbol: '£'
  },
  {
    icon: 'yemen',
    value: 'Yemen',
    code: 967,
    currencySymbol: '﷼'
  },
  {
    icon: 'zambia',
    value: 'Zambia',
    code: 260,
    currencySymbol: 'K'
  },
  {
    icon: 'zimbabwe',
    value: 'Zimbabwe',
    code: 263,
    currencySymbol: '$'
  }
];

export default nations;
